/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum MonitoringStyle {
    TRAFFICON = 'TRAFFICON',
    ILE_FSA = 'ILE_FSA',
    RADGIPFEL = 'RADGIPFEL',
}
